import { Pipe, PipeTransform } from '@angular/core';
import {
    ReferencedAuthorityDto,
    SimpleAuthorityDto
} from '@flyfreely-portal-ui/flyfreely';
import { formatAuthorityTypeName } from './formatAuthority.pipe';

@Pipe({ name: 'formatMaintenanceAuthority' })
export class FormatMaintenanceAuthorityPipe implements PipeTransform {
    transform(
        authority: SimpleAuthorityDto | ReferencedAuthorityDto,
        currentAuthority?: SimpleAuthorityDto | ReferencedAuthorityDto,
        showIdentifier = false
    ) {
        if (
            authority == null ||
            !(authority instanceof Object) ||
            authority.authorityType == null ||
            authority.organisation == null
        ) {
            return 'None';
        }

        if (
            currentAuthority != null &&
            authority.id != null &&
            authority.id === currentAuthority.id
        ) {
            return 'This authority';
        }

        const authorityName = formatAuthorityTypeName(authority);

        const identifier =
            authority.identifier != null &&
            authority.authorityType.hasIdentifier
                ? `${authority.authorityType.identifierLabel} ${authority.identifier}`
                : '';

        return showIdentifier
            ? `${authority.organisation.name}'s ${authorityName} ${identifier}`
            : `${authority.organisation.name}'s ${authorityName}`;
    }
}
